import React from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';


const ModalForm = ({ isOpenModalForm, onCloseModal, onSubmitModalClick, submitText, onCancelModalClick, modalFormMessage, modalInput, setModalInput, onKeyDownModal }) => {

  
  return (
    <>
      <Modal isOpen={isOpenModalForm} onRequestClose={onCloseModal} >
        <button onClick={onCancelModalClick} className='float-right'>
          <FontAwesomeIcon icon={faXmark} color='#e33c30' className='text-xl' />
        </button>
        <h2 className="mt-4 text-sm    xs:mt-8 xs:text-sm     sm:mt-8 sm:text-base   md:mt-4 md:text-base    smLaptop:mt-4 smLaptop:text-lg    lg:mt-4 lg:text-lg    xl:mt-4 xl:text-lg   font-bold  text-[#54709e]">{modalFormMessage}</h2>
        <input className='mt-4 px-1   w-[200px] h-8   xs:w-[230px] xs:h-8  sm:w-[260px] sm:h-8    md:w-[280px] md:h-8    smLaptop:w-[310px] smLaptop:h-8     lg:w-[340px] lg:h-8    xl:w-[360px] xl:h-8  text-[#28507d]  border border-blue-200 shadow-blue-200 shadow-lg rounded  focus:outline-blue-500'
          type="text"
          value={modalInput}
          onChange={(event) => setModalInput(event.target.value)} 
          onKeyDown={onKeyDownModal}
          required
        />
        <div className='mt-8           text-xs    xs:mt-4 xs:text-xs     sm:mt-4 sm:text-sm   md:mt-4 md:text-sm    smLaptop:mt-4 smLaptop:text-base    lg:mt-4 lg:text-base    xl:mt-4 xl:text-base          float-right'>
        <button onClick={onCancelModalClick} className='bg-red-500 text-white mr-2 py-1 px-4 rounded'>Close</button> 
        <button className='bg-blue-500 text-white py-1 px-3 rounded mr-2' onClick={onSubmitModalClick}>{submitText}</button>
        </div>
      </Modal>
    </>
  )
}



export default ModalForm;